
import PropTypes from 'prop-types'
import { ListGroup, ListGroupItem } from 'reactstrap'
import CheckoutShipmentMethod from 'domains/customer-checkout/molecules/shipment-method'

const CustomerCheckoutShipmentMethodList = ({
  shipmentMethods,
  handleClickShippingMethod
}) => (
  <ListGroup>
    {
      shipmentMethods.map((method, index) => {
        const errorMessages       = method?.error_messages
        const isEmptyErrorMessage = Object.keys(errorMessages).length === 0
        const onClickItem         = () => {
          if (isEmptyErrorMessage) handleClickShippingMethod(method)
          return
        }
        return (
          <ListGroupItem
            action
            key={ `checkout-shipment-method-list-item-${index}` }
            onClick={ onClickItem }
          >
            <CheckoutShipmentMethod shipmentMethod={ method } />
          </ListGroupItem>
        )
      })
    }
  </ListGroup>
)

CustomerCheckoutShipmentMethodList.defaultProps = {
  shipmentMethods: [ {
    courier      : 'Default Courier',
    service_type : 'Default Service Type',
    etd_from     : -1,
    etd_thru     : -1,
    cost         : -1
  } ],
  handleClickShippingMethod: () => alert('Clicked on Shipping Method')
}

CustomerCheckoutShipmentMethodList.propTypes = {
  shipmentMethods: PropTypes.arrayOf(
    PropTypes.shape({
      courier      : PropTypes.string.isRequired,
      service_type : PropTypes.string.isRequired,
      etd_from     : PropTypes.number.isRequired,
      etd_thru     : PropTypes.number.isRequired,
      cost         : PropTypes.number.isRequired
    }).isRequired
  ),
  handleClickShippingMethod: PropTypes.func.isRequired
}

export default CustomerCheckoutShipmentMethodList